import { Anchor } from "@mantine/core";
import React from "react";

const URL_REGEX = /(\b(?:https?:\/\/|www\.)[^\s<]+)/gi;
const TRAILING_PUNCTUATION_REGEX = /[.,;:!?)]*$/;

const getHref = (url: string) => (/^https?:\/\//i.test(url) ? url : `https://${url}`);

const toSafeText = (value: unknown): string => {
  if (value == null) return "";
  if (typeof value === "string") return value;

  try {
    return String(value);
  } catch {
    return "";
  }
};

const splitTrailingPunctuation = (url: string) => {
  const trailing = url.match(TRAILING_PUNCTUATION_REGEX)?.[0] ?? "";
  return {
    url: trailing.length > 0 ? url.slice(0, -trailing.length) : url,
    trailing,
  };
};

export const LinkifiedText = ({ text }: { text?: unknown }) => {
  try {
    const value = toSafeText(text);
    const parts = value.split(URL_REGEX);

    return (
      <>
        {parts.map((part, index) => {
          if (part.match(URL_REGEX) == null) {
            return <React.Fragment key={index}>{part}</React.Fragment>;
          }

          const { url, trailing } = splitTrailingPunctuation(part);

          return (
            <React.Fragment key={index}>
              <Anchor
                href={getHref(url)}
                target="_blank"
                rel="noopener noreferrer"
                onClick={(event) => event.stopPropagation()}
              >
                {url}
              </Anchor>
              {trailing}
            </React.Fragment>
          );
        })}
      </>
    );
  } catch {
    return <>{toSafeText(text)}</>;
  }
};
